import { Link } from "react-router-dom";
import {
  SPLASH_BG,
  VERUM_LOGO,
  TYPHOON_LOGO,
  TYPHOON_TEXT,
  GRILLA_SITE_LOGO,
  KICKSTART_SITE_LOGO,
} from "@/constants";
import CustomCursor from "@/components/CustomCursor";
import { useSiteCursor } from "@/hooks/use-site-cursor";

const BRAND_CARDS = [
  {
    name: "Grilla Africa",
    href: "https://www.drinkgrilla.com/",
    logo: GRILLA_SITE_LOGO,
    copy: "Thoughtful hydration with a bold performance-led identity.",
    linkTestId: "typhoon-page-grilla-link",
    logoTestId: "typhoon-page-grilla-logo",
  },
  {
    name: "KickStart Kenya Football",
    displayName: "KickStart\nKenya Football",
    href: "https://kickstartkenyafootball.com/",
    logo: KICKSTART_SITE_LOGO,
    copy: "A football-first platform driving visibility, support, and momentum.",
    linkTestId: "typhoon-page-kickstart-link",
    logoTestId: "typhoon-page-kickstart-logo",
  },
];

const TyphoonPageHeader = () => (
  <header className="detail-page-header" data-testid="typhoon-page-header">
    <Link to="/" state={{ skipSplash: true }} className="detail-back-link logo-hover-target" data-testid="typhoon-page-back-link">
      Back to Verum Inventa
    </Link>
    <img src={VERUM_LOGO} alt="Verum Inventa" className="detail-page-verum-logo logo-hover-target" data-testid="typhoon-page-verum-logo" />
  </header>
);

const TyphoonHeroSection = () => (
  <section className="detail-hero-card" data-testid="typhoon-page-hero">
    <div className="logo-container" data-testid="typhoon-page-logo-container">
      <img src={TYPHOON_LOGO} alt="Typhoon Sports Group" className="detail-typhoon-logo logo-hover-target" data-testid="typhoon-page-logo" />
    </div>
    <img src={TYPHOON_TEXT} alt="Typhoon Sports Group" className="detail-typhoon-text logo-hover-target" data-testid="typhoon-page-text" />
    <p className="detail-page-eyebrow" data-testid="typhoon-page-eyebrow">Typhoon Sports Group</p>
    <p className="detail-page-copy" data-testid="typhoon-page-copy">
      A focused sports portfolio page featuring the linked brand destinations connected to Typhoon.
    </p>
  </section>
);

const TyphoonBrandCard = ({ brand }) => (
  <article className="detail-brand-card" key={brand.name} data-testid={`${brand.linkTestId}-card`}>
    <a
      href={brand.href}
      target="_blank"
      rel="noreferrer"
      className="detail-brand-logo-link logo-hover-target"
      data-testid={brand.linkTestId}
    >
      <img src={brand.logo} alt={`${brand.name} website logo`} className="detail-brand-logo" data-testid={brand.logoTestId} />
    </a>
    <p className="detail-brand-name detail-brand-name-multiline" data-testid={`${brand.linkTestId}-name`}>{brand.displayName ?? brand.name}</p>
    <p className="detail-brand-copy" data-testid={`${brand.linkTestId}-copy`}>{brand.copy}</p>
    <a
      href={brand.href}
      target="_blank"
      rel="noreferrer"
      className="detail-brand-cta logo-hover-target"
      data-testid={`${brand.linkTestId}-cta`}
    >
      Visit website
    </a>
  </article>
);

const TyphoonBrandGrid = () => (
  <section className="detail-brand-grid" data-testid="typhoon-page-brand-grid">
    {BRAND_CARDS.map((brand) => (
      <TyphoonBrandCard brand={brand} key={brand.name} />
    ))}
  </section>
);

export default function TyphoonPage() {
  const { cursorPos, isHoveringLogo } = useSiteCursor({ scrollToTopOnMount: true });

  return (
    <div className="verum-container detail-page" data-testid="typhoon-page">
      <div className="fixed-background" style={{ backgroundImage: `url(${SPLASH_BG})` }} />
      <CustomCursor cursorPos={cursorPos} isHoveringLogo={isHoveringLogo} />

      <div className="detail-page-shell" data-testid="typhoon-page-shell">
        <TyphoonPageHeader />

        <main className="detail-page-content" data-testid="typhoon-page-content">
          <TyphoonHeroSection />
          <TyphoonBrandGrid />
        </main>
      </div>
    </div>
  );
}